<template>

	<div class="bkf7 gameall_list">
		<el-container>
			<div class="inter">

				<div class="article-list">
					<div class="article-list-box bg-fff over-hidden br-5">
						<div class="title-big flex-a pl-10 pr-10 no-dark-mode"
							style="background: rgb(67, 67, 67); color: rgb(255, 255, 255);">
							<div class="title-box">
								<div class="img">
									<div class="left-img"><img src="https://oss.pzds.com/imgv2/order.png"></div>
									新闻公告
								</div>
							</div>
							<div class="right"><span class="text-fff cp">返回</span></div>
						</div>
						<div class="content">
							<div class="nav mb-20">
								<div class="nav-item text-aaa cp" :class="{'active' : channel == 17}"
									@click="choseMenu(17)">
									全部
								</div>
								<div class="nav-item text-aaa cp" :class="{'active' : channel == item.id}"
									@click="choseMenu(item.id)" v-for="item in channel_list">
									{{item.name}}
								</div>
							</div>
							<ul element-loading-text="加载中..." class="item-ul">
								<li class="item-li" v-for="item in list">
									<a :href="'/news/detail?id='+item.id">

										<div class="text-565">
											{{item.title}}
										</div>
									</a>
								</li>
							</ul>
							<div class="page tr mr-20">

								<el-pagination class="pagebox" background @size-change="handleSizeChange"
									@current-change="handleCurrentChange" :current-page="current_page"
									:page-sizes="[10, 20, 30, 40, 50]" :page-size="10"
									layout="total, sizes, prev, pager, next, jumper" :total="total">
								</el-pagination>
							</div>
						</div>
					</div>
				</div>
			</div>
		</el-container>
	</div>

</template>
<script>
	export default {
		data() {
			return {

				list: [],
				current_page: 1,
				channel: 17,
				pagesize: 12,
				channel_list: [],
				now_index: 0,

			}
		},
		created: function(data) {
			this.getchannelist()
			this.addRandomData(this.channel, this.current_page);
		},
		watch: {
			$route() {

			}
		},
		methods: {
			choseMenu(item) {

				this.channel = item;
				this.list = [];
				this.current_page = 1;
				this.addRandomData(this.channel, this.current_page);
			},
			getchannelist() {
				var that = this;
				this.rq.requests.post("api/game/cms/channel_list", {
					id: that.channel,
				}).then(res => {
					that.channel_list = res.data;
				}).catch(error => {

				})
			},

			addRandomData(current_page, ) {
				this.loading = true;
				var that = this;

				this.rq.requests.post("api/game/cms/arclist", {
					channel: that.channel,
					page: that.current_page,
					// pagesize: that.pagesize,
					paginate: true,
					type: 'sons'
				}).then(res => {
					that.last_page = res.data.last_page;
					that.current_page = res.data.current_page;
					that.total = res.data.total;
					that.list = res.data.data;
					that.loading = false

				}).catch(error => {

				})
			},
			handleSizeChange(val) {
				this.pagesize = val;
				this.addRandomData();
			},
			handleCurrentChange(val) {
				this.current_page = val;
				this.addRandomData();
			},


		}
	}
</script>
<style>
	.zuhao .el-radio__input {
		display: flex !important;
		align-items: center;
	}

	.zuhao .el-radio__input.is-checked .el-radio__inner {
		border-color: #508aff;
		background: #508aff;
	}

	.zuhao .el-radio__input.is-checked+.el-radio__label {
		color: #508aff;
	}
</style>